
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/capabilities/defense-technology-intelligence",
      function () {
        return require("private-next-pages/capabilities/defense-technology-intelligence.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/capabilities/defense-technology-intelligence"])
      });
    }
  